import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

export const MSProgramByIdKey = 'mission-specialist-program-by-id'

type MSProgramResponse = {
  programId: string
  name: string
  displayName: string
  operatorDisplayName: string
  color: string
  iconType?: string
  image: {
    location?: string
  }
  orgProfile: {
    name: string
  }
  active: boolean
}

export function useGetById(programId?: string) {
  return useQuery({
    queryKey: [MSProgramByIdKey, programId],
    queryFn: async () =>
      (await apiClient.get<MSProgramResponse>(`/int/v2/mission-specialist/programs/${programId}`)).data,
    enabled: Boolean(programId),
    refetchOnWindowFocus: false,
  })
}
